module.exports = __webpack_public_path__ + "img/feature_buy_zh.5f8606f1.png";